//@ts-nocheck
import { memo, useEffect, useRef, useState } from 'react'
import { Dimensions, View as RNView, ViewStyle } from 'react-native'
import { DataProvider, LayoutProvider, RecyclerListView } from 'recyclerlistview'
interface CustomSectionListProps {
  renderItem: any
  data: []
  renderHeader: any
  selected?: any
  renderEmpty?: any
  extraData: Array<any>
  measureDetail?: (width: string) => void
}

const CustomSectionList = memo(
  ({ renderItem, data, renderHeader, selected, renderEmpty, extraData, measureDetail }: CustomSectionListProps) => {
    const [_dataProvider, setDataProvider] = useState(
      new DataProvider((r1, r2) => {
        return r1 !== r2
      }).cloneWithRows(data),
    )

    const parentViewRef: any = useRef<any>()

    useEffect(() => {
      setDataProvider((dataProvider) => dataProvider.cloneWithRows(data))
    }, [data])

    const _renderRecycleView = (_type: any, item: any, index: any) => {
      if (_type === 'HEADER') {
        return renderHeader({ item, index })
      } else {
        return renderItem({ item, index })
      }
    }

    const [_layoutProvider, setLayoutProvider] = useState(null)

    useEffect(() => {
      setLayoutProvider(
        new LayoutProvider(
          (index) => {
            if (data[index] && data[index].type === 'HEADER') {
              return 'HEADER'
            }
            return 'ITEM'
          },
          (type, dim) => {
            switch (type) {
              case 'HEADER':
                dim.width = Math.round(Dimensions.get('window').width)
                dim.height = 40
                break
              default:
                dim.width = Math.round(Dimensions.get('window').width)
                dim.height = 110
                break
            }
          },
        ),
      )
    }, [data, selected])
    const styledTheme: any = styles()
    if (!_layoutProvider) {
      return null
    }
    return (
      <RNView
        ref={parentViewRef}
        style={[styledTheme.outerContainer]}
        onLayout={(event: any) => {
          if (parentViewRef) {
            parentViewRef?.current?.measure((x: any, y: any, width: any, height: any, pageX: any, pageY: any) => {
              measureDetail(width)
            })
          }
        }}>
        {data && data.length > 0 && (
          <RecyclerListView
            style={{ minHeight: 100 }}
            removeClippedSubviews
            dataProvider={_dataProvider}
            rowRenderer={_renderRecycleView}
            forceNonDeterministicRendering={true}
            layoutProvider={_layoutProvider}
            extendedState={extraData}
          />
        )}
        {(!data || data.length === 0) && renderEmpty && renderEmpty()}
      </RNView>
    )
  },
)

export const styles = (): any => ({
  outerContainer: { flex: 1 } as ViewStyle,
})

export { CustomSectionList }
